import { Product, ProductConfig } from '@easylife365/react';
import headerLogo from './images/header_logo.svg';
import splashLogo from './images/splash_logo.svg';
import { initializeTranslations } from './i18n';

export const identityAppId: string = import.meta.env.VITE_AUTH_CLIENTID;

export const productConfig: ProductConfig = {
  i18n: {
    languages: ['en', 'de', 'es', 'fr', 'hu', 'it', 'nl', 'pl', 'tr'],
    onInit: (languages?: string[]) => {
      initializeTranslations(languages);
    },
  },
  auth: {
    auth: {
      clientId: identityAppId,
      authority: import.meta.env.VITE_AUTH_AUTHORITY,
      redirectUri: import.meta.env.VITE_AUTH_REDIRECTURI,
    },
    graphScope: import.meta.env.VITE_EASY_GRAPHSCOPE,
    tokenEndPoint: import.meta.env.VITE_EASY_TOKENENDPOINT,
  },
  api: {
    scopes: [import.meta.env.VITE_EASY_EASYLIFESCOPE],
    baseUrl: import.meta.env.VITE_EASY_APIENDPOINT,
  },
  app: {
    baseUrl: import.meta.env.VITE_EASY_ADMINBASEURL,
    onboardingUrl: import.meta.env.VITE_EASY_ONBOARDINGURL,
    headerLogo: headerLogo,
    splashLogo: splashLogo,
    name: 'EasyLife 365 Identity',
    cdnUrl: import.meta.env.VITE_EASY_CDNENDPOINT,
  },
  telemetry: {
    appName: import.meta.env.VITE_EASY_APPNAME,
    // The ring's shared Application Insights instance (preferred); the instrumentation key stays as fallback.
    connectionString: import.meta.env.VITE_EASY_APPINSIGHTS_CONNECTIONSTRING || undefined,
    instrumentationKey: import.meta.env.VITE_EASY_APPINSIGHTS,
  } as ProductConfig['telemetry'],
  product: Product.Identity,
};
